<template>
  <v-container>
    <v-row no-gutters>
      <v-col
        v-if="showCreated && (item.createdDateDb)"
        cols="12"
        sm="6"
      >
        <span
          class="caption grey--text font-weight-light col-sm-4"
        >
          <v-icon small>mdi-calendar-month</v-icon>
          <strong>Created On:</strong> {{ item.createdDateDb }}
        </span>
      </v-col>
      <v-col
        v-if="showCreated && (item.createdByName || item.createdByUsername)"
        cols="12"
        sm="6"
      >
        <span
          class="caption grey--text font-weight-light col-sm-4"
        >
          <v-icon small>mdi-account</v-icon>
          <strong>Created By:</strong> {{ item.createdByName || item.createdByUsername }}
        </span>
      </v-col>
      <v-col
        v-if="item.updatedDateDb"
        cols="12"
        sm="6"
      >
        <span
          class="caption grey--text font-weight-light col-sm-4"
        >
          <v-icon small>mdi-calendar-edit</v-icon>
          <strong>Updated On:</strong> {{ item.updatedDateDb }}
        </span>
      </v-col>
      <v-col
        v-if="item.updatedByName || item.updatedByUsername"
        cols="12"
        sm="6"
      >
        <span
          class="caption grey--text font-weight-light col-sm-4"
        >
          <v-icon small>mdi-account-edit</v-icon>
          <strong>Updated By:</strong> {{ item.updatedByName || item.updatedByUsername }}
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: null,
      },
      preferUpdateOnly: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      showCreated () {
        let showIt = true
        if (this.preferUpdateOnly) {
          if (this.item && this.item.updatedDateDb) {
            showIt = false
          }
        }
        return showIt
      },
    },
  }
</script>
